import { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setHeader } from "../../store/settings/settingsSlice";
import style from "./wallet.module.css";
import { ArrowDown2 } from "iconsax-react";
import info_icon from '../../assets/images/info_icon.svg'
import bitcoinIcon from '../../assets/images/bitcoin.svg'
import ethIcon from "../../assets/images/ethereum-eth-logo.png";
import ltcIcon from "../../assets/images/litecoin-ltc-logo.svg";
import usdtIcon from "../../assets/images/tether-usdt-logo.svg";
import xrpIcon from "../../assets/images/xrp-xrp-logo.svg";
import dogeIcon from "../../assets/images/dogecoin-doge-logo.svg";
import trxIcon from "../../assets/images/tron-trx-logo.svg";
import bnbIcon from "../../assets/images/bnb-bnb-logo.svg";
import usdcIcon from "../../assets/images/usd-coin-usdc-logo.svg";
import solIcon from "../../assets/images/solana-sol-logo.svg";
import xlmIcon from "../../assets/images/stellar-xlm-logo.svg";
import swapIcon from '../../assets/images/arrange-square.svg'
import withdrawIcon from '../../assets/images/withdraw.svg'
import receiveIcon from '../../assets/images/receive.svg'
import moneyIcon from '../../assets/images/moneys.svg'
import arrow_left from '../../assets/images/arrow-left.svg'
import successIcon from '../../assets/images/check-mark.svg'
import arrowCircleRight from '../../assets/images/arrow-circle-right.svg'
import transactionTypeIcon from '../../assets/images/typeIcon.svg'
import { useLocation } from "react-router-dom";
import { Eye, EyeSlash, InfoCircle } from "iconsax-react";
import spin_circle from '../../assets/images/Loader anim.png'
import Modal from '../modal/Modal';
import { useNavigate } from "react-router-dom";
import { browserName } from "react-device-detect";
import PinInput from "react-pin-input";
import Lottie from "lottie-react";
import loader from "../../assets/lottie/loader.json";
import cogoToast from "cogo-toast";
import { createSwapTransaction, generateSwapQuotation, tradeCryptoToFiat, fiatToCrypto, cryptoWithdrawal, cryptoWithdrawalByTag } from "../../store/crypto/cryptoActions";
import { getWalletBalance, fetchAstroName,fetchExchangeConfig, InitiateExchange } from "../../store/wallet/walletActions";
import { getCryptoCoins, addCryptoAccount, getCryptoAccounts } from "../../store/settings/settingsActions";
import { getUserCryptoTransactions } from "../../store/crypto/cryptoActions";
import moment from "moment";

const coinIcons = {
  BTC: bitcoinIcon,
  ETH: ethIcon,
  LTC: ltcIcon,
  USDT: usdtIcon,
  XRP: xrpIcon,
  DOGE: dogeIcon,
  TRX: trxIcon,
  BNB: bnbIcon,
  USDC: usdcIcon,
  SOL: solIcon,
  XLM: xlmIcon,
};

const TRANSACTION_TYPE_ENUM = {
  CRYPTO_TO_CRYPTO: "crypto_to_crypto",
  CRYPTO_TO_FIAT: "crypto_to_fiat",
  FIAT_TO_CRYPTO: "fiat_to_crypto",
  CRYPTO_DEPOSIT: "crypto_deposit",
  CRYPTO_WITHDRAWAL: "crypto_withdrawal"
};

const CryptoWalletPage = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    
    // ========== SWAP STATES ==========
    const [isSwapModalOpen, setIsSwapModalOpen] = useState(false);
    const [isInstantSwapOpen, setIsInstantSwapOpen] = useState(false);
    const [toCoin, setToCoin] = useState(null);
    const [swapAmount, setSwapAmount] = useState("");
    const [receiveAmount, setReceiveAmount] = useState("");
    const [openToSelect, setOpenToSelect] = useState(false);
    const [openFromSelect, setOpenFromSelect] = useState(false);
    const [swapType, setSwapType] = useState("CRYPTO_TO_CRYPTO");
    const [openSwapType, setOpenSwapType] = useState(false);
    const [swapTypeLabel, setSwapTypeLabel] = useState("Crypto to Crypto");
    const [isSwapInitiated, setIsSwapInitiated] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isSuccessModal, setSuccessModal] = useState(false);
    const [isLoadingQuotation, setIsLoadingQuotation] = useState(false);
    const [quotationError, setQuotationError] = useState("");
    const [currentRate, setCurrentRate] = useState("");
    const [swapTimer, setSwapTimer] = useState(10);
    
    // ========== WITHDRAWAL STATES ==========
    const [isCryptoWithdrawModalOpen, setIsCryptoWithdrawModalOpen] = useState(false);
    const [currencyExchangeSettingsId, setCurrencyExchangeSettingsId] = useState(null);
    const [isWalletAddressModal, setIsWalletAddressModal] = useState(false);
    const [isInternalTransferModal, setIsInternalTransferModal] = useState(false);
    const [walletAddress, setWalletAddress] = useState("");
    const [openNetwork, setOpenNetwork] = useState(false);
    const [selectedNetworkName, setSelectedNetworkName] = useState("");
    const [selectedNetworkId, setSelectedNetworkId] = useState("");
    const [withdrawalType, setWithdrawalType] = useState("");
    const [astroTag, setAstroTag] = useState("");
    const [withdrawAmount, setWithdrawAmount] = useState("");
    const [isWithdrawInitiated, setIsWithdrawInitiated] = useState(false);
    const [putPass, setPutPass] = useState(false);
    const [trPin, setTrPin] = useState("");
    const [pinDisabled, setPinDisabled] = useState(true);
    const [accountName, setAccountName] = useState("");
    const [userNotFound, setUserNotFound] = useState(false);
    const [prevAstroTag, setPrevAstroTag] = useState("");
    const [isLoadingName, setIsLoadingName] = useState(false);
    const [withdrawalFeeData, setWithdrawalFeeData] = useState(null);
    const [isLoadingFee, setIsLoadingFee] = useState(false);
    const [feeError, setFeeError] = useState("");
    const [showCryptoFavoritesDropdown, setShowCryptoFavoritesDropdown] = useState(false);
    const [showAddFavoriteModal, setShowAddFavoriteModal] = useState(false);
    const [newFavCryptoAddress, setNewFavCryptoAddress] = useState("");
    const [newFavCryptoName, setNewFavCryptoName] = useState("");
    const [isSavingFav, setIsSavingFav] = useState(false);
    const [selectedCryptoForWithdraw, setSelectedCryptoForWithdraw] = useState(null);
    const [isCryptoReceiveModalOpen, setIsCryptoReceiveModalOpen] = useState(false);

    // ========== REDUX SELECTORS ==========
    const { cryptocoins = [] } = useSelector((state) => state.settings);
    const walletData = useSelector((state) => state.wallet.data);
    const allCryptoAccounts = useSelector((state) => state.settings.allCryptoAccounts);
    const exchangeConfig = useSelector((state) => state.wallet.exchangeConfig);

    
    // ========== REFS ==========
    const toSelectRef = useRef(null);
    const swapTypeRef = useRef(null);
    const debounceRef = useRef(null);
    const debouncedFeeRef = useRef(null);
    const astroDebounceRef = useRef(null);
    let pinEle = useRef();
    
    // ========== URL PARAMS ==========
    const params = new URLSearchParams(location.search);
    const currency = params.get("currency")?.toUpperCase() || "BTC";
    
    // ========== UI STATES ==========
    const [visible, setVisible] = useState(true);
    const [transactions, setTransactions] = useState([]);
    const [transactionsMeta, setTransactionsMeta] = useState({ page: 0, per_page: 15, count: 0 });
    const [txPage, setTxPage] = useState(0);
    const [txPerPage, setTxPerPage] = useState(15);
    const [isLoadingTransactions, setIsLoadingTransactions] = useState(false);

    const swapTypeOptions = [
        { id: "CRYPTO_TO_CRYPTO", name: "Crypto to Crypto" },
        { id: "CRYPTO_TO_FIAT", name: "Crypto to Fiat" },
        { id: "FIAT_TO_CRYPTO", name: "Fiat to Crypto" },
        { id: "FIAT_TO_FIAT", name: "Fiat to Fiat" }
    ];

    // Find the coin object from Redux
    const coin = cryptocoins.find(c => c.currency?.toUpperCase() === currency);

    // Enhanced selectedCoin with price change data
    const selectedCoin = coin ? {
        name: coin.name,
        symbol: coin.currency?.toUpperCase(),
        icon: coinIcons[coin.currency?.toUpperCase()] || bitcoinIcon,
        balance: coin.balance || "0.00",
        price_change_percentage: coin.price_change_percentage || 0,
        coin_type_id: coin.coin_type_id,
        quidaxUserId: coin.quidaxUserId,
        networks: coin.networks || []
    } : {
        name: currency,
        symbol: currency,
        icon: coinIcons[currency] || bitcoinIcon,
        balance: "0.00",
        price_change_percentage: 0,
        coin_type_id: null,
        quidaxUserId: null,
        networks: []
    };

    // Build dynamic crypto data from Redux
    const cryptoDataFromRedux = cryptocoins.reduce((acc, coin) => {
        acc[coin.code?.toUpperCase()] = {
            name: coin.name,
            symbol: coin.code?.toUpperCase(),
            icon: coinIcons[coin.code?.toUpperCase()] || bitcoinIcon,
            balance: coin.balance || "0.00",
            id: coin.coin_type_id
        };
        return acc;
    }, {});

    const [fromCoin, setFromCoin] = useState(
        cryptoDataFromRedux[currency] || {
            name: currency,
            symbol: currency,
            icon: coinIcons[currency] || bitcoinIcon,
            balance: coin ? coin.balance || "0.00" : "0.00",
            id: coin ? coin.coin_type_id : null
        }
    );

    // Available networks for withdrawal
    const availableNetworks = selectedCryptoForWithdraw ? 
        (cryptocoins.find(c => c.currency?.toUpperCase() === selectedCryptoForWithdraw.symbol)?.networks || []).map(network => ({
            id: network.id,
            name: network.name || network.id.toUpperCase(),
        })) : [];

    // ========== HELPER FUNCTIONS ==========
    const getFiatIcon = (currencyCode) => {
        const flagIcons = {
            NGN: "https://flagcdn.com/ng.svg",
            GHS: "https://flagcdn.com/gh.svg",
            USD: "https://flagcdn.com/us.svg"
        };
        return flagIcons[currencyCode] || "https://flagcdn.com/un.svg";
    };

    const formatType = (type) => {
        if (!type) return "";
        const t = type.toString().toLowerCase();
        if (t.includes("crypto_to_crypto") || t.includes("swap")) return "Swap";
        if (t.includes("crypto_deposit") || t.includes("deposit") || t.includes("receive")) return "Receive";
        if (t.includes("crypto_withdrawal") || t.includes("withdraw")) return "Withdraw";
        if (t.includes("fiat_to_crypto")) return "Buy";
        if (t.includes("crypto_to_fiat")) return "Sell";
        return type.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
    };

    const getTransactionAmountAndCurrency = (tx) => {
    if (!tx || !tx.type) return `${tx?.amount || "0"} `;
    
    const txType = tx.type.toLowerCase();
    let amount = "0";
    let currency = "";
    
    if (txType === "fiat_to_crypto") {
        amount = tx.data?.final_amount_received || "0";
        currency = tx.data?.to_currency || "";
    } else if (txType === "crypto_to_crypto") {
        amount = tx.data?.final_amount_received || "0";
        currency = tx.data?.from_currency || "";
    } else if (txType === "crypto_withdrawal") {
        amount = tx.data?.amount_debited || "0";
        currency = tx.data?.from_currency || "";
    } else if (txType === "crypto_to_fiat") {
        amount = tx.data?.amount_usd || "0";
        currency = tx.data?.from_currency || "";
    } else if (txType === "crypto_deposit") {
        amount = tx.data?.final_amount_received || tx.amount || "0";
        currency = tx.data?.from_currency || "";
    } else {
        // Fallback for unknown types
        amount = tx.amount || "0";
        currency = (tx.data?.from_currency || "").toUpperCase();
    }
    
    return `${amount} ${currency}`;
};

    const getQuidaxUserId = useCallback(() => {
        if (swapType === "FIAT_TO_CRYPTO") {
            const toCoinData = cryptocoins.find(coin => coin.currency?.toUpperCase() === toCoin?.symbol);
            return toCoinData?.quidaxUserId || null;
        } else {
            const fromCoinData = cryptocoins.find(coin => coin.currency?.toUpperCase() === fromCoin.symbol);
            return fromCoinData?.quidaxUserId || null;
        }
    }, [cryptocoins, fromCoin.symbol, toCoin?.symbol, swapType]);

 const getAvailableToAssets = (swapType) => {
    if (swapType === "CRYPTO_TO_CRYPTO") {
        return cryptocoins
            .filter(coin => coin.currency?.toUpperCase() !== fromCoin.symbol)
            .map(coin => ({
                name: coin.name,
                symbol: coin.currency?.toUpperCase(),
                icon: coinIcons[coin.currency?.toUpperCase()] || bitcoinIcon,
                balance: coin.balance || "0.00"
            }));
    } else if (swapType === "FIAT_TO_CRYPTO") {
        return cryptocoins.map(coin => ({
            name: coin.name,
            symbol: coin.currency?.toUpperCase(),
            icon: coinIcons[coin.currency?.toUpperCase()] || bitcoinIcon,
            balance: coin.balance || "0.00",
            id: coin.coin_type_id
        }));
    } else if (swapType === "FIAT_TO_FIAT") {
        if (!walletData?.fiatWallets) return [];
        return walletData.fiatWallets
            .filter(wallet => wallet.is_active && wallet.Currency.code !== fromCoin?.symbol)
            .map(wallet => ({
                name: wallet.Currency.name,
                symbol: wallet.Currency.code,
                icon: getFiatIcon(wallet.Currency.code),
                balance: wallet.balance || "0.00",
                id: wallet.id
            }));
    } else {
        // CRYPTO_TO_FIAT
        if (!walletData?.fiatWallets) return [];
        return walletData.fiatWallets
            .filter(wallet => wallet.is_active)
            .map(wallet => ({
                name: wallet.Currency.name,
                symbol: wallet.Currency.code,
                icon: getFiatIcon(wallet.Currency.code),
                balance: wallet.balance || "0.00",
                id: wallet.id
            }));
    }
};

    const getAdaptiveDelay = useCallback((prev, current) => {
        const TYPING_SPEED_DELAY = { fast: 800, moderate: 500, slow: 300 };
        const diff = current.length - prev.length;
        const typingSpeed = Math.abs(diff);
        if (typingSpeed > 3) return TYPING_SPEED_DELAY.fast;
        if (typingSpeed > 1) return TYPING_SPEED_DELAY.moderate;
        return TYPING_SPEED_DELAY.slow;
    }, []);

    // ========== SWAP HANDLERS ==========
    const handleSwapType = (e, typeId) => {
        setOpenSwapType(false);
        setSwapTypeLabel(e.target.textContent);
        setSwapType(typeId);
        resetSelections(typeId);
    };

   const resetSelections = (newSwapType) => {
    if (newSwapType === "FIAT_TO_CRYPTO") {
        if (walletData?.fiatWallets?.length > 0) {
            const firstFiat = walletData.fiatWallets.find(w => w.is_active && w.Currency.code !== "USD") || walletData.fiatWallets[0];
            setFromCoin({
                name: firstFiat.Currency.name,
                symbol: firstFiat.Currency.code,
                icon: getFiatIcon(firstFiat.Currency.code),
                balance: firstFiat.balance || "0.00",
                id: firstFiat.id
            });
        }
            setToCoin(null);
        } else if (newSwapType === "FIAT_TO_FIAT") {
            if (walletData?.fiatWallets?.length > 0) {
                const firstFiat = walletData.fiatWallets.find(w => w.is_active) || walletData.fiatWallets[0];
                setFromCoin({
                    name: firstFiat.Currency.name,
                    symbol: firstFiat.Currency.code,
                    icon: getFiatIcon(firstFiat.Currency.code),
                    balance: firstFiat.balance || "0.00",
                    id: firstFiat.id
                });
            }
            setToCoin(null);
        } else if (newSwapType === "CRYPTO_TO_CRYPTO") {
            setFromCoin(
                cryptoDataFromRedux[currency] || {
                    name: currency,
                    symbol: currency,
                    icon: coinIcons[currency] || bitcoinIcon,
                    balance: coin ? coin.balance || "0.00" : "0.00",
                    id: coin ? coin.coin_type_id : null
                }
            );
            setToCoin(null);
        } else {
            setFromCoin(
                cryptoDataFromRedux[currency] || {
                    name: currency,
                    symbol: currency,
                    icon: coinIcons[currency] || bitcoinIcon,
                    balance: coin ? coin.balance || "0.00" : "0.00",
                    id: coin ? coin.coin_type_id : null
                }
            );
            setToCoin(null);
        }
        setSwapAmount("");
        setReceiveAmount("");
        setCurrentRate("");
        setQuotationError("");
        setCurrencyExchangeSettingsId(null);
        if (debounceRef.current) clearTimeout(debounceRef.current);
    };

   const handleSwapQuotation = useCallback(async (amount) => {
    if (!amount || !toCoin || !fromCoin || parseFloat(amount) <= 0) {
        setReceiveAmount("");
        setCurrentRate("");
        return;
    }

        // Handle Fiat to Fiat using exchangeConfig (no API call needed)
        if (swapType === "FIAT_TO_FIAT") {
            const exchangeRateData = exchangeConfig.find(
                (rate) =>
                    rate.BaseCurrency.code === fromCoin.symbol && 
                    rate.TargetCurrency.code === toCoin.symbol
            );

            if (exchangeRateData) {
                const rate = parseFloat(exchangeRateData.exchange_rate);
                const calculatedReceiveAmount = parseFloat(amount) * rate;
                setReceiveAmount(calculatedReceiveAmount.toFixed(2));
                setCurrencyExchangeSettingsId(exchangeRateData.id);
                
                // Format rate display (handle rates < 1)
                if (rate < 1) {
                    const inverseRate = (1 / rate).toFixed(2);
                    setCurrentRate(`1 ${toCoin.symbol} = ${inverseRate} ${fromCoin.symbol}`);
                } else {
                    setCurrentRate(`1 ${fromCoin.symbol} = ${rate.toFixed(2)} ${toCoin.symbol}`);
                }
                setQuotationError("");
            } else {
                setQuotationError("Exchange rate not found for the selected currencies.");
                setReceiveAmount("");
                setCurrentRate("");
                setCurrencyExchangeSettingsId(null);
            }
            return;
        }

        // Existing crypto swap logic
        const quidaxUserId = getQuidaxUserId();
        if (!quidaxUserId) {
            setQuotationError("Unable to get wallet information");
            return;
        }
        setIsLoadingQuotation(true);
        setQuotationError("");
        const quotationData = {
            from_currency: fromCoin.symbol.toLowerCase(),
            to_currency: toCoin.symbol.toLowerCase(),
            from_amount: amount,
            quidaxUserId: quidaxUserId,
            transaction_type: TRANSACTION_TYPE_ENUM[swapType]
        };
        try {
            const result = await dispatch(generateSwapQuotation(quotationData));
            if (result.type === "generateSwapQuotation/fulfilled") {
                const quotation = result.payload;
                if (swapType === "CRYPTO_TO_CRYPTO") {
                    const finalAmount = quotation.data?.final_amount;
                    const quotedPrice = quotation.data?.quoted_price;
                    setReceiveAmount(finalAmount);
                    setCurrentRate(`1 ${fromCoin.symbol} = ${parseFloat(quotedPrice).toLocaleString(undefined, { maximumFractionDigits: 8 })} ${toCoin.symbol}`);
                }
                else if (swapType === "FIAT_TO_CRYPTO") {
                        const rate = quotation.data?.rate;
                        const finalPayout = quotation.data?.final_payout;
                        setReceiveAmount(finalPayout);
                        setCurrentRate(`1 ${toCoin.symbol} = ${parseFloat(rate).toLocaleString(undefined, { maximumFractionDigits: 8 })} ${fromCoin.symbol}`);
                  } 
                else if (swapType === "CRYPTO_TO_FIAT") {
                    const rate = quotation.data?.amount_usd;
                    const finalPayout = quotation.data?.final_payout;
                    setReceiveAmount(finalPayout);
                    setCurrentRate(`1 ${fromCoin.symbol} = ${parseFloat(rate).toLocaleString(undefined, { maximumFractionDigits: 8 })} USD`);
                }
                else {
                    const rate = quotation.data?.rate;
                    const finalPayout = quotation.data?.final_payout;
                    setReceiveAmount(finalPayout);
                    setCurrentRate(`1 ${fromCoin.symbol} = ${parseFloat(rate).toLocaleString(undefined, { maximumFractionDigits: 8 })} ${toCoin.symbol}`);
                }
            } else {
                setQuotationError("Failed to get swap quotation");
                setReceiveAmount("");
                setCurrentRate("");
            }
        } catch (error) {
            console.error("Quotation error:", error);
            setQuotationError("Failed to get swap quotation");
            setReceiveAmount("");
            setCurrentRate("");
        } finally {
            setIsLoadingQuotation(false);
        }
    }, [dispatch, fromCoin, toCoin, getQuidaxUserId, swapType, exchangeConfig]);

    const debouncedQuotation = useCallback((amount) => {
        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
            handleSwapQuotation(amount);
        }, 800);
    }, [handleSwapQuotation]);

   const handleFinalSwap = async () => {
    setIsSwapInitiated(false);
    setIsInstantSwapOpen(false);
    setIsOpen(true);
    try {
        let result;
        if (swapType === "CRYPTO_TO_CRYPTO") {
            const quidaxUserId = getQuidaxUserId();
            const swapData = {
                from_currency: fromCoin.symbol.toLowerCase(),
                to_currency: toCoin.symbol.toLowerCase(),
                from_amount: swapAmount,
                quidaxUserId: quidaxUserId
            };
            result = await dispatch(createSwapTransaction(swapData));
        } else if (swapType === "CRYPTO_TO_FIAT") {
            const tradeData = {
                coinTypeId: fromCoin.id,
                amount: swapAmount,
                rate: parseFloat(currentRate.split("=")[1]),
                payoutAmount: receiveAmount,
                creditWalletId: toCoin.id,
                coinAmount: swapAmount,
                sellerRemarks: ""
            };
            result = await dispatch(tradeCryptoToFiat(tradeData));
        } else if (swapType === "FIAT_TO_CRYPTO") {
            const fiatToCryptoData = {
                coinTypeId: toCoin.id,
                debitWalletId: fromCoin.id,
                amountFiat: swapAmount
            };
            result = await dispatch(fiatToCrypto(fiatToCryptoData));
        } else if (swapType === "FIAT_TO_FIAT") {
            result = await dispatch(InitiateExchange({
                amount: parseFloat(swapAmount),
                currencyExchangeSettingsId: currencyExchangeSettingsId
            }));
        }
        
        if (result && (result.type?.endsWith("/fulfilled"))) {
            setIsOpen(false);
            setSuccessModal(true);
            setSwapAmount("");
            setReceiveAmount("");
            setCurrentRate("");
            setToCoin(null);
            setSwapType("CRYPTO_TO_CRYPTO");
            setSwapTypeLabel("Crypto to Crypto");
            setCurrencyExchangeSettingsId(null);
            dispatch(getCryptoCoins());
            dispatch(getWalletBalance());
        } else {
            setIsOpen(false);
            setSwapAmount("");
            setReceiveAmount("");
            setCurrentRate("");
            setToCoin(null);
            setSwapType("CRYPTO_TO_CRYPTO");
            setSwapTypeLabel("Crypto to Crypto");
            setCurrencyExchangeSettingsId(null);
        }
        } catch (error) {
            setIsOpen(false);
            setSwapAmount("");
            setReceiveAmount("");
            setCurrentRate("");
            setToCoin(null);
            setSwapType("CRYPTO_TO_CRYPTO");
            setSwapTypeLabel("Crypto to Crypto");
            setCurrencyExchangeSettingsId(null);
            console.error("Swap error:", error);
        }
    };

    const handleInstantSwap = () => {
        setIsSwapModalOpen(false);
        setIsInstantSwapOpen(true);
    };

    const handleToAssetSelect = (asset) => {
        setToCoin(asset);
        setOpenToSelect(false);
        if (swapAmount && parseFloat(swapAmount) > 0) {
            setReceiveAmount("");
            setCurrentRate("");
            setTimeout(() => {
                handleSwapQuotation(swapAmount);
            }, 100);
        }
    };

    // ========== WITHDRAWAL HANDLERS ==========
    const fetchAstroAccountName = useCallback(async (tag) => {
        setIsLoadingName(true);
        setUserNotFound(false);
        dispatch(fetchAstroName({ name: tag })).then((res) => {
            if (res?.type === "fetchAstroName/fulfilled") {
                setIsLoadingName(false);
                setAccountName(`${res.payload.data.data.firstname} ${res.payload.data.data.lastname}`);
            } else if (res?.type === "fetchAstroName/rejected") {
                setIsLoadingName(false);
                setAccountName("");
                setUserNotFound(true);
            }
        });
    }, [dispatch]);

    const fetchWithdrawalFee = useCallback(async (amountValue) => {
        if (!amountValue || !selectedNetworkId || !selectedCryptoForWithdraw) {
            setWithdrawalFeeData(null);
            setFeeError("");
            return;
        }
        setIsLoadingFee(true);
        setFeeError("");
        try {
            const quotationData = {
                from_currency: selectedCryptoForWithdraw.symbol.toLowerCase(),
                to_currency: selectedCryptoForWithdraw.symbol.toLowerCase(),
                from_amount: amountValue.toString(),
                network: selectedNetworkId,
                quidaxUserId: selectedCryptoForWithdraw.quidaxUserId,
                transaction_type: "crypto_withdrawal"
            };
            const result = await dispatch(generateSwapQuotation(quotationData));
            if (result.type === "generateSwapQuotation/fulfilled") {
                setWithdrawalFeeData(result.payload.data);
                setFeeError("");
            } else {
                setWithdrawalFeeData(null);
                setFeeError("Unable to calculate fee. Please try again.");
            }
        } catch (error) {
            console.error("Fee calculation error:", error);
            setWithdrawalFeeData(null);
            setFeeError("Unable to calculate fee");
        } finally {
            setIsLoadingFee(false);
        }
    }, [dispatch, selectedNetworkId, selectedCryptoForWithdraw]);

    const debouncedFetchFee = useCallback((amountValue) => {
        if (debouncedFeeRef.current) clearTimeout(debouncedFeeRef.current);
        debouncedFeeRef.current = setTimeout(() => {
            fetchWithdrawalFee(amountValue);
        }, 800);
    }, [fetchWithdrawalFee]);

    const handleNetwork = (e, id) => {
        setOpenNetwork(false);
        setSelectedNetworkName(e.target.textContent);
        setSelectedNetworkId(id);
    };

    const handleSelectCryptoFromFavorites = (favorite) => {
        setWalletAddress(favorite.wallet_address);
        const matchedNetwork = availableNetworks.find(
            network => network.id?.toLowerCase() === favorite.network?.toLowerCase()
        );
        if (matchedNetwork) {
            setSelectedNetworkName(matchedNetwork.name);
            setSelectedNetworkId(matchedNetwork.id);
        }
        setShowCryptoFavoritesDropdown(false);
    };

    const handleClearCryptoFavorite = () => {
        setWalletAddress("");
        setSelectedNetworkName("");
        setSelectedNetworkId("");
        setShowCryptoFavoritesDropdown(false);
    };

    const handleSaveCryptoFavorite = async () => {
        if (!newFavCryptoAddress || !newFavCryptoName || !selectedCryptoForWithdraw || !selectedNetworkId) {
            cogoToast.error("Please fill all required fields", { position: "top-right" });
            return;
        }
        setIsSavingFav(true);
        try {
            const payload = {
                walletAddress: newFavCryptoAddress,
                coinType: selectedCryptoForWithdraw.symbol,
                network: selectedNetworkId,
                coinName: newFavCryptoName
            };
            const result = await dispatch(addCryptoAccount(payload));
            if (result.type === "addCryptoAccount/fulfilled") {
                setNewFavCryptoAddress("");
                setNewFavCryptoName("");
                setShowAddFavoriteModal(false);
                dispatch(getCryptoAccounts());
            }
        } catch (error) {
            console.error("Error saving favorite:", error);
        } finally {
            setIsSavingFav(false);
        }
    };

    const handleWithdrawal = async () => {
        setIsOpen(true);
        setPutPass(false);
        if (withdrawalType === "walletAddress") {
            try {
                const payload = {
                    coinTypeId: selectedCryptoForWithdraw?.coin_type_id,
                    amount: parseFloat(withdrawAmount),
                    coinNetwork: selectedNetworkId,
                    walletAddress: walletAddress,
                    transactionPin: trPin
                };
                const res = await dispatch(cryptoWithdrawal(payload));
                setIsOpen(false);
                if (res?.type === "cryptoWithdrawal/fulfilled") {
                    setSuccessModal(true);
                    setWithdrawAmount("");
                    setWalletAddress("");
                    setSelectedNetworkName("");
                    setSelectedNetworkId("");
                    setTrPin("");
                    setWithdrawalFeeData(null);
                    dispatch(getCryptoCoins());
                }
            } catch (err) {
                setIsOpen(false);
            }
            return;
        }
        if (withdrawalType === "internalTransfer") {
            try {
                const payload = {
                    coinTypeId: selectedCryptoForWithdraw?.coin_type_id,
                    amount: parseFloat(withdrawAmount),
                    recipientTag: astroTag,
                    transactionPin: trPin
                };
                const res = await dispatch(cryptoWithdrawalByTag(payload));
                setIsOpen(false);
                if (res?.type === "cryptoWithdrawalByTag/fulfilled") {
                    setSuccessModal(true);
                    setWithdrawAmount("");
                    setAstroTag("");
                    setAccountName("");
                    setTrPin("");
                    dispatch(getCryptoCoins());
                }
            } catch (err) {
                setIsOpen(false);
            }
            return;
        }
    };

    const handleOpenWithdrawModal = () => {
        setSelectedCryptoForWithdraw(selectedCoin);
        setIsCryptoWithdrawModalOpen(true);
        setWithdrawalFeeData(null);
        setFeeError("");
    };

    // ========== TRANSACTION HANDLERS ==========
    const fetchTransactions = useCallback(
        async (pageParam = txPage, perPageParam = txPerPage) => {
            setIsLoadingTransactions(true);
            try {
                const result = await dispatch(
                    getUserCryptoTransactions({
                        coinType: currency.toLowerCase(),
                        page: pageParam,
                        per_page: perPageParam,
                        mode: 'instant',
                    })
                );
                if (result?.type === "getUserCryptoTransactions/fulfilled") {
                    const payloadData = result.payload?.data || {};
                    setTransactions(payloadData.transactions || []);
                    setTransactionsMeta(payloadData.meta || { page: pageParam, per_page: perPageParam, count: 0 });
                } else {
                    setTransactions([]);
                    setTransactionsMeta({ page: pageParam, per_page: perPageParam, count: 0 });
                }
            } catch (err) {
                setTransactions([]);
                setTransactionsMeta({ page: pageParam, per_page: perPageParam, count: 0 });
            } finally {
                setIsLoadingTransactions(false);
            }
        },
        [dispatch, currency, txPage, txPerPage]
    );

    // ========== EFFECTS ==========
    useEffect(() => {
        function handleClickOutside(event) {
            if (toSelectRef.current && !toSelectRef.current.contains(event.target)) {
                setOpenToSelect(false);
            }
            if (swapTypeRef.current && !swapTypeRef.current.contains(event.target)) {
                setOpenSwapType(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        if (isSwapInitiated) {
            setSwapTimer(10);
            const interval = setInterval(() => {
                setSwapTimer(prev => {
                    if (prev <= 1) {
                        clearInterval(interval);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
            return () => clearInterval(interval);
        }
    }, [isSwapInitiated]);

    useEffect(() => {
        return () => {
            if (debounceRef.current) clearTimeout(debounceRef.current);
            if (debouncedFeeRef.current) clearTimeout(debouncedFeeRef.current);
            if (astroDebounceRef.current) clearTimeout(astroDebounceRef.current);
        };
    }, []);

    useEffect(() => {
        if (!astroTag) {
            setAccountName("");
            setUserNotFound(false);
            return;
        }
        const delay = getAdaptiveDelay(prevAstroTag, astroTag);
        setPrevAstroTag(astroTag);
        if (astroDebounceRef.current) clearTimeout(astroDebounceRef.current);
        astroDebounceRef.current = setTimeout(() => {
            fetchAstroAccountName(astroTag);
        }, delay);
        return () => {
            if (astroDebounceRef.current) clearTimeout(astroDebounceRef.current);
        };
    }, [astroTag, fetchAstroAccountName, getAdaptiveDelay, prevAstroTag]);

    const networkSelectRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (networkSelectRef.current && !networkSelectRef.current.contains(e.target)) {
                setOpenNetwork(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        if (trPin !== "" && trPin.length === 5) {
            setPinDisabled(false);
        } else {
            setPinDisabled(true);
        }
    }, [trPin]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (event.target.id !== "cryptoFavoritesBtn" && !event.target.closest('[data-crypto-favorites]')) {
                setShowCryptoFavoritesDropdown(false);
            }
        };
        if (showCryptoFavoritesDropdown) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [showCryptoFavoritesDropdown]);

    useEffect(() => {
        fetchTransactions(txPage, txPerPage);
    }, [fetchTransactions, txPage, txPerPage, currency]);

    useEffect(() => {
        dispatch(setHeader(`${selectedCoin.name} Wallet`));
        dispatch(getWalletBalance());
        dispatch(getCryptoAccounts());
        dispatch(fetchExchangeConfig());
    }, [dispatch, selectedCoin.name]);

    // ========== RENDER ==========
    return (
        <>
            {/* ===== SWAP MODAL - Type Selection ===== */}
            <Modal
                title={`Swap ${selectedCoin.symbol}`}
                minWidth="40%"
                canClose
                modalOpen={isSwapModalOpen}
                setModalOpen={setIsSwapModalOpen}
            >
                <div className={style.swapModalSubtitle}>
                    Buy or sell crypto instantly at<br />current market price
                </div>
                <div className={style.swapModalOptions}>
                    <div className={style.swapModalOption} onClick={handleInstantSwap}>
                        <div className={style.swapModalIconWrap}>
                            <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
                                <path d="M7 17l-4-4 4-4M17 8l4 4-4 4" stroke="#40196D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                        <div>
                            <div className={style.swapModalOptionTitle}>Instant Swap</div>
                            <div className={style.swapModalOptionDesc}>Swap any two assets instantly<br />(Fiat and Crypto)</div>
                        </div>
                        <div className={style.swapModalArrow}>
                            <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
                                <path d="M9 18l6-6-6-6" stroke="#40196D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                    </div>
                       <div className={style.swapModalOption} onClick={() => {
                        setIsSwapModalOpen(false);
                        const targetCurrency = currency === "USDT" ? "BTC" : currency;
                        navigate(`/order-book?currency=${targetCurrency}`);
                        }}>
                        <div className={style.swapModalIconWrap}>
                            <svg width="28" height="28" fill="none" viewBox="0 0 24 24">
                                <rect x="4" y="4" width="16" height="16" rx="3" stroke="#40196D" strokeWidth="1.5"/>
                                <path d="M8 8h8M8 12h8M8 16h4" stroke="#40196D" strokeWidth="1.5" strokeLinecap="round"/>
                            </svg>
                        </div>
                        <div>
                            <div className={style.swapModalOptionTitle}>Order Book</div>
                            <div className={style.swapModalOptionDesc}>Buy or sell crypto on your terms.</div>
                        </div>
                        <div className={style.swapModalArrow}>
                            <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
                                <path d="M9 18l6-6-6-6" stroke="#40196D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                    </div>
                </div>
            </Modal>

            {/* ===== INSTANT SWAP MODAL ===== */}
            <Modal
                title="Instant Swap"
                minWidth="40%"
                canClose
                modalOpen={isInstantSwapOpen}
                setModalOpen={setIsInstantSwapOpen}
            >
                {!isSwapInitiated ? (
                    <form className={style.swapForm}>
                        {/* SWAP TYPE SELECTOR */}
                        <div className={style.labelPut}>
                            <label>Swap Type</label>
                            <div className={style.select} style={{marginTop: '10px'}} ref={swapTypeRef}>
                                <div 
                                    id="swapType"
                                    name="swapType" 
                                    className={style.selectInput}
                                    onClick={() => setOpenSwapType((prev) => !prev)}
                                >
                                    <input
                                        type="text"
                                        disabled={browserName === "Firefox" ? false : true}
                                        value={swapTypeLabel}
                                        placeholder="Select Swap Type"
                                        style={{pointerEvents: "none"}}
                                    />
                                    <ArrowDown2
                                        style={{
                                            transform: openSwapType ? "translateY(-50%) rotate(-540deg)" : "translateY(-50%) rotate(0deg)",
                                            pointerEvents: "none",
                                        }}
                                        className={style.dropDown}
                                        size="20"
                                        color="#909090"
                                        variant="Bold"
                                    />
                                </div>
                                <div
                                    style={{
                                        height: openSwapType ? "fit-content" : "0px",
                                        maxHeight: 'fit-content',
                                    }}
                                    className={style.option}
                                >
                                    {swapTypeOptions.map((option, index) => (
                                        <p
                                            id="swapTypeDrop"
                                            key={option.id}
                                            onClick={(e) => handleSwapType(e, option.id)}
                                            style={{
                                                borderBottom: `${index !== swapTypeOptions.length - 1 ? '1px #90909042 solid': ''}`,
                                                padding: '12px 16px',
                                                margin: 0
                                            }}
                                        >
                                            {option.name}
                                        </p>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* FROM */}
                        <div className={style.labelPut} style={{marginTop: '12px'}}>
                            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                                <label>From</label>
                                <p style={{margin: '0px', color: '#40196D', fontWeight: 600, fontSize: 14}}>
                                    Balance: {fromCoin.balance} {fromCoin.symbol}
                                </p>
                            </div>
                            {swapType === "FIAT_TO_CRYPTO" || swapType === "FIAT_TO_FIAT" ? (
                                <div className={style.select} style={{marginTop: '10px'}}>
                                    <div
                                        className={style.selectInput}
                                        onClick={() => setOpenFromSelect((prev) => !prev)}
                                    >
                                        <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                                            <img src={fromCoin.icon} alt={fromCoin.symbol} className={style.swapCoinIcon} />
                                            <span>{fromCoin.symbol}</span>
                                        </div>
                                        <ArrowDown2
                                            style={{
                                                transform: openFromSelect ? "translateY(-50%) rotate(-540deg)" : "translateY(-50%) rotate(0deg)",
                                                pointerEvents: "none",
                                            }}
                                            className={style.dropDown}
                                            size="20"
                                            color="#909090"
                                            variant="Bold"
                                        />
                                    </div>
                                    <div
                                        style={{
                                            height: openFromSelect ? "fit-content" : "0px",
                                            maxHeight: openFromSelect ? "200px" : "0px",
                                            overflowY: "auto"
                                        }}
                                        className={style.option}
                                    >
                                       {walletData?.fiatWallets.filter(wallet => {
                                        if (swapType === "FIAT_TO_CRYPTO") {
                                            return wallet.is_active && wallet.Currency.code !== "USD";
                                        }
                                        return wallet.is_active;
                                    }).map((wallet, index) => (
                                            <p
                                                key={wallet.id}
                                                onClick={() => {
                                                    setFromCoin({
                                                        name: wallet.Currency.name,
                                                        symbol: wallet.Currency.code,
                                                        icon: getFiatIcon(wallet.Currency.code),
                                                        balance: wallet.balance || "0.00",
                                                        id: wallet.id
                                                    });
                                                    setOpenFromSelect(false);
                                                    setSwapAmount("");
                                                    setReceiveAmount("");
                                                    setCurrentRate("");
                                                }}
                                                style={{
                                                    borderBottom: `${index !== walletData.fiatWallets.length - 1 ? '1px #90909042 solid': ''}`,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '10px',
                                                    padding: '12px 16px'
                                                }}
                                            >
                                                <img src={getFiatIcon(wallet.Currency.code)} alt={wallet.Currency.code} style={{width: '24px', height: '24px', borderRadius: '50%'}} />
                                                <span>{wallet.Currency.code} - {wallet.Currency.name}</span>
                                                <span style={{ fontSize: '12px', color: '#909090' }}>
                                                    {parseFloat(wallet.balance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 8 })} {wallet.Currency.code}
                                                </span>
                                            </p>
                                        ))}
                                    </div>
                                </div>
                            ) : (
                                <div className={style.swapSelectBox} style={{cursor: 'not-allowed'}}>
                                    <div className={style.swapCoinBadge}>
                                        <img src={fromCoin.icon} alt={fromCoin.symbol} className={style.swapCoinIcon} />
                                        <span className={style.swapCoinSymbol}>{fromCoin.symbol}</span>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* AMOUNT */}
                        <div className={style.labelPut} style={{marginTop: '10px'}}>
                            <label>Amount<span style={{ color: "#FF0000" }}>*</span></label>
                            <div className={style.input} style={{position: 'relative', marginTop: '10px'}}>
                                <input
                                    type="number"
                                    name="swapAmount"
                                    placeholder="Enter Swap Amount"
                                    value={swapAmount}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (swapType === "FIAT_TO_CRYPTO" && (value === "" || parseFloat(value) <= 1)) {
                                            setSwapAmount("");
                                            setReceiveAmount("");
                                            setCurrentRate("");
                                            return;
                                        }
                                        setSwapAmount(value);
                                        setReceiveAmount("");
                                        setCurrentRate("");
                                        if (toCoin && value && parseFloat(value) > 0) {
                                            debouncedQuotation(value);
                                        }
                                    }}
                                />
                                <div style={{
                                    position: 'absolute',
                                    right: '12px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    display: 'flex',
                                    gap: '8px'
                                }}>
                                    {['25%', '50%', '75%', 'Max'].map((percent) => (
                                        <button
                                            key={percent}
                                            type="button"
                                            style={{
                                                background: '#f5f5f5',
                                                border: 'none',
                                                borderRadius: '4px',
                                                padding: '4px 8px',
                                                fontSize: '11px',
                                                color: '#666',
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => {
                                                const balance = parseFloat(fromCoin.balance || 0);
                                                let amount;
                                                if (percent === 'Max') {
                                                    amount = balance.toString();
                                                } else {
                                                    const percentage = parseInt(percent) / 100;
                                                    amount = (balance * percentage).toFixed(6);
                                                }
                                                setSwapAmount(amount);
                                                setReceiveAmount("");
                                                setCurrentRate("");
                                                if (toCoin && amount && parseFloat(amount) > 0) {
                                                    handleSwapQuotation(amount);
                                                }
                                            }}
                                        >
                                            {percent}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* TO */}
                        <div className={style.labelPut} style={{marginTop: '10px'}}>
                            <label>To</label>
                            <div className={style.select} style={{marginTop: '10px'}} ref={toSelectRef}>
                                <div 
                                    id="toSelect"
                                    className={style.selectInput}
                                    onClick={() => setOpenToSelect((prev) => !prev)}
                                >
                                    <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                                        {toCoin ? (
                                            <>
                                                <img src={toCoin.icon} alt={toCoin.symbol} className={style.swapCoinIcon} />
                                                <span>{toCoin.symbol}</span>
                                            </>
                                        ) : (
                                            <span style={{color: '#909090'}}>
                                                  Select {swapType === "CRYPTO_TO_CRYPTO" || swapType === "FIAT_TO_CRYPTO" ? "Crypto" : "Fiat"}
                                            </span>
                                        )}
                                    </div>
                                    <ArrowDown2
                                        style={{
                                            transform: openToSelect ? "translateY(-50%) rotate(-540deg)" : "translateY(-50%) rotate(0deg)",
                                            pointerEvents: "none",
                                        }}
                                        className={style.dropDown}
                                        size="20"
                                        color="#909090"
                                        variant="Bold"
                                    />
                                </div>
                                <div
                                    style={{
                                        height: openToSelect ? "fit-content" : "0px",
                                        maxHeight: openToSelect ? "200px" : "0px",
                                        overflowY: "auto"
                                    }}
                                    className={style.option}
                                >
                                    {getAvailableToAssets(swapType).length > 0 ? (
                                        getAvailableToAssets(swapType).map((asset, index) => (
                                            <p
                                                id="toSelectDrop"
                                                key={asset.symbol}
                                                onClick={() => handleToAssetSelect(asset)}
                                                style={{
                                                    borderBottom: `${index !== getAvailableToAssets(swapType).length - 1 ? '1px #90909042 solid': ''}`,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-between',
                                                    gap: '10px',
                                                    padding: '12px 16px'
                                                }}
                                            >
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <img src={asset.icon} alt={asset.symbol} style={{width: '24px', height: '24px', borderRadius: '50%'}} />
                                                    <span>{asset.symbol} - {asset.name}</span>
                                                </div>
                                                <span style={{ fontSize: '12px', color: '#909090' }}>
                                                    {parseFloat(asset.balance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 8 })} {asset.symbol}
                                                </span>
                                            </p>
                                        ))
                                    ) : (
                                        <p style={{ padding: '12px 16px', color: '#FF0000' }}>
                                            {swapType === "CRYPTO_TO_CRYPTO" ? "No available cryptocurrencies to swap to." : "No fiat wallets available."}
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Rate Info */}
                        <div className={style.swapRateInfo}>
                            <img src={info_icon} alt="info" style={{ width: 18, height: 18, marginRight: 6 }} />
                            {isLoadingQuotation ? (
                                "Getting current rate..."
                            ) : quotationError ? (
                                <span style={{ color: '#F40000' }}>{quotationError}</span>
                            ) : currentRate ? (
                                currentRate
                            ) : (
                                "Enter amount to see rate"
                            )}
                        </div>

                        {/* You Receive */}
                        <div className={style.labelPut}>
                            <label>You Receive</label>
                            <div className={style.input} style={{marginTop: '10px'}}>
                                <input
                                    type="text"
                                    name="receiveAmount"
                                    placeholder="Amount"
                                    value={receiveAmount ? Number(receiveAmount).toLocaleString(undefined, { maximumFractionDigits: 8 }) : ""}
                                    disabled
                                />
                            </div>
                        </div>

                        {/* Disclaimer */}
                        <div className={style.swapDisclaimer}>
                            Swapping may be subject to changing rates.<br />
                            Values displayed are only estimates of current market price.
                        </div>

                        {/* Swap Button */}
                        <button
                            className={style.swapBtn}
                            type="button"
                            disabled={!swapAmount || !toCoin || isLoadingQuotation || !receiveAmount}
                            onClick={() => setIsSwapInitiated(true)}
                        >
                            {isLoadingQuotation ? "Getting Rate..." : "Swap"}
                        </button>
                    </form>
                ) : (
                    /* Confirmation Step */
                    <div style={{ marginTop: '20px' }}>
                        <div
                            onClick={() => setIsSwapInitiated(false)}
                            style={{
                                width: '20px',
                                height: '20px',
                                background: '#40196d1a',
                                borderRadius: '50%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                cursor: 'pointer'
                            }}
                        >
                            <img src={arrow_left} alt="arrow left" />
                        </div>

                        <div style={{ display: "flex", justifyContent: "center", marginBottom: 24 }}>
                            <img src={fromCoin.icon} alt={fromCoin.symbol} style={{ width: 64, height: 64, borderRadius: "50%", zIndex: 2 }} />
                            <img src={toCoin.icon} alt={toCoin.symbol} style={{ width: 64, height: 64, borderRadius: "50%", marginLeft: -20, zIndex: 1 }} />
                        </div>

                        <div className={style.confirmSwapBox} style={{
                            background: '#F5F3F7',
                            marginTop: '20px',
                            borderRadius: '20px',
                            padding: '25px 25px'
                        }}>
                            <p style={{ color: '#212121', fontWeight: '400', textAlign: 'left', fontSize: 14, marginBottom: 0 }}>
                                Please check transaction details
                            </p>

                            <div style={{ marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center' }}>
                                <div><img src={fromCoin.icon} alt={fromCoin.name} width={24} height={24} /></div>
                                <div>
                                    <h6 style={{ color: '#90909080', fontWeight: '400', fontSize: 14 }}>Swap From</h6>
                                    <p style={{ marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14 }}>
                                        {fromCoin.name} Wallet
                                    </p>
                                </div>
                            </div>

                            <div style={{ marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center' }}>
                                <div><img src={toCoin.icon} alt={toCoin.name} width={24} height={24} /></div>
                                <div>
                                    <h6 style={{ color: '#90909080', fontWeight: '400', fontSize: 14 }}>To</h6>
                                    <p style={{ marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14 }}>
                                        {toCoin.name} Wallet
                                    </p>
                                </div>
                            </div>

                            <div style={{ marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center' }}>
                                <div><img src={moneyIcon} alt='moneyIcon' /></div>
                                <div>
                                    <h6 style={{ color: '#90909080', fontWeight: '400', fontSize: 14 }}>Swap Amount</h6>
                                    <p style={{ marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14 }}>
                                        {swapAmount} {fromCoin.symbol}
                                    </p>
                                </div>
                            </div>

                            <div style={{ marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center' }}>
                                <div><img src={moneyIcon} alt='moneyIcon' /></div>
                                <div>
                                    <h6 style={{ color: '#90909080', fontWeight: '400', fontSize: 14 }}>You Receive</h6>
                                    <p style={{ marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14 }}>
                                        {receiveAmount ? Number(receiveAmount).toLocaleString(undefined, { maximumFractionDigits: 8 }) : "0"} {toCoin.symbol}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className={style.confirmSwapTimerBox} style={{
                            background: '#f8f3ff',
                            borderRadius: '12px',
                            padding: '16px',
                            margin: '18px 0',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            fontSize: '15px'
                        }}>
                            <span style={{ fontWeight: 600 }}>00:{swapTimer.toString().padStart(2, '0')}</span>
                            <span style={{ fontSize: 14 }}>you have {swapTimer} second{swapTimer !== 1 ? "s" : ""} to continue with this market price</span>
                        </div>

                        <button className={style.swapBtn} style={{ marginTop: 24 }} onClick={handleFinalSwap}>
                            Proceed
                        </button>
                    </div>
                )}
            </Modal>
            
            {/* Receive Crypto */}
            <Modal
                title={`Receive ${selectedCoin.name || ""}`}
                minWidth="40%"
                canClose
                modalOpen={isCryptoReceiveModalOpen}
                setModalOpen={setIsCryptoReceiveModalOpen}
                        >
                <div style={{ marginTop: '18px', textAlign: 'center' }}>
                    <p style={{
                        color: '#B6B6B6',
                        fontSize: 14,
                        marginBottom: 32,
                        marginTop: 0,
                        fontWeight: 400,
                    }}>
                        Please select one of the options below to receive funds<br />into your wallet
                    </p>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
                        <div 
                            className={style.swapModalOption}
                onClick={() => {
                    setIsCryptoReceiveModalOpen(false);
                    navigate(
                        `/deposit-with-crypto?option=wallet-address&currency=${selectedCoin.symbol}&id=${selectedCoin.quidaxUserId}`
                    );
                }}
            >
                <div className={style.swapModalIconWrap}>
                    <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
                        <path d="M2 7.5A2.5 2.5 0 0 1 4.5 5h15A2.5 2.5 0 0 1 22 7.5v9A2.5 2.5 0 0 1 19.5 19h-15A2.5 2.5 0 0 1 2 16.5v-9Z" stroke="#40196D" strokeWidth="1.5"/>
                        <circle cx="17" cy="12" r="1" fill="#40196D"/>
                    </svg>
                </div>
                <div>
                    <div className={style.swapModalOptionTitle} style={{textAlign:'left'}}>Wallet Address</div>
                    <div className={style.swapModalOptionDesc}>Receive funds using your wallet address</div>
                </div>
                <div className={style.swapModalArrow}>
                    <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
                        <path d="M9 18l6-6-6-6" stroke="#40196D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
            </div>
            <div
                className={style.swapModalOption}
                onClick={() => {
                    setIsCryptoReceiveModalOpen(false);
                    navigate(
                        `/deposit-with-crypto?option=internal-transfer&currency=${selectedCoin.symbol}&id=${selectedCoin.quidaxUserId}`
                    );
                }}
            >
                <div className={style.swapModalIconWrap}>
                    <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
                        <circle cx="6" cy="12" r="2" stroke="#40196D" strokeWidth="1.5"/>
                        <circle cx="18" cy="6" r="2" stroke="#40196D" strokeWidth="1.5"/>
                        <circle cx="18" cy="18" r="2" stroke="#40196D" strokeWidth="1.5"/>
                        <path d="M7.76 10.62l2.48-1.24M7.76 13.38l2.48 1.24M15.52 7.24l-2.48 1.24M15.52 16.76l-2.48-1.24" stroke="#40196D" strokeWidth="1.5"/>
                    </svg>
                </div>
                <div>
                    <div className={style.swapModalOptionTitle} style={{textAlign:'left'}}>Internal Transfer</div>
                    <div className={style.swapModalOptionDesc}>Receive funds from an Astro user</div>
                </div>
                <div className={style.swapModalArrow}>
                    <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
                        <path d="M9 18l6-6-6-6" stroke="#40196D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
                    </div>
                </div>
            </div>
            </Modal>

            {/* ===== CRYPTO WITHDRAW TYPE MODAL ===== */}
            <Modal
                title={`Withdraw ${selectedCryptoForWithdraw?.name || selectedCoin.name}`}
                minWidth="40%"
                canClose
                modalOpen={isCryptoWithdrawModalOpen}
                setModalOpen={setIsCryptoWithdrawModalOpen}
            >
                <div style={{ marginTop: '18px', textAlign: 'center' }}>
                    <p style={{ color: '#B6B6B6', fontSize: 14, marginBottom: 32, marginTop: 0, fontWeight: 400 }}>
                        Please select one of the options below to withdraw from
                    </p>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
                        <div
                            className={style.swapModalOption}
                            onClick={() => {
                                setIsCryptoWithdrawModalOpen(false);
                                setIsWalletAddressModal(true);
                                setSelectedNetworkName("");
                                setSelectedNetworkId("");
                                setWalletAddress("");
                                setWithdrawAmount("");
                                setIsWithdrawInitiated(false);
                                setWithdrawalFeeData(null);
                            }}
                           
                        >
                            <div className={style.swapModalIconWrap}>
                                <svg width="24" height="24" fill="none" viewBox="0 0 24 24"><path d="M2 7.5A2.5 2.5 0 0 1 4.5 5h15A2.5 2.5 0 0 1 22 7.5v9A2.5 2.5 0 0 1 19.5 19h-15A2.5 2.5 0 0 1 2 16.5v-9Z" stroke="#40196D" strokeWidth="1.5"/><circle cx="17" cy="12" r="1" fill="#40196D"/></svg>
                            </div>
                            <div style={{ flex: 1, textAlign: 'left' }}>
                                <div style={{ fontWeight: 600, fontSize: 14, color: '#212121' }}>Wallet Address</div>
                                <div style={{ fontSize: 12, color: '#909090' }}>Send crypto to other wallet address</div>
                            </div>
                            <div className={style.cryptoModalArrow}>
                                <img src={arrowCircleRight} alt="arrow right" />
                            </div>
                        </div>
                        <div
                            className={style.swapModalOption}
                            onClick={() => {
                                setIsCryptoWithdrawModalOpen(false);
                                setIsInternalTransferModal(true);
                                setAstroTag("");
                                setAccountName("");
                                setWithdrawAmount("");
                                setIsWithdrawInitiated(false);
                            }}
                        >
                            <div className={style.swapModalIconWrap}>
                                <svg width="24" height="24" fill="none" viewBox="0 0 24 24"><circle cx="6" cy="12" r="2" stroke="#40196D" strokeWidth="1.5"/><circle cx="18" cy="6" r="2" stroke="#40196D" strokeWidth="1.5"/><circle cx="18" cy="18" r="2" stroke="#40196D" strokeWidth="1.5"/><path d="M7.76 10.62l2.48-1.24M7.76 13.38l2.48 1.24M15.52 7.24l-2.48 1.24M15.52 16.76l-2.48-1.24" stroke="#40196D" strokeWidth="1.5"/></svg>
                            </div>
                            <div style={{ flex: 1, textAlign: 'left' }}>
                                <div style={{ fontWeight: 600, fontSize: 14, color: '#212121' }}>Internal Transfer</div>
                                <div style={{ fontSize: 12, color: '#909090' }}>Send crypto to an Astro user</div>
                            </div>
                            <div className={style.cryptoModalArrow}>
                                <img src={arrowCircleRight} alt="arrow right" />
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>

            {/* ===== WALLET ADDRESS WITHDRAW MODAL ===== */}
            <Modal
                title={`Withdraw ${selectedCryptoForWithdraw?.name || selectedCoin.name}`}
                minWidth="40%"
                canClose
                modalOpen={isWalletAddressModal}
                setModalOpen={setIsWalletAddressModal}
            >
                {!isWithdrawInitiated ? (
                    <div style={{ marginTop: '25px' }}>
                        {/* From Wallet */}
                        <div className={style.labelPut}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <label htmlFor="wallet">From Wallet</label>
                                <p style={{ margin: '0px', color: '#40196D', fontWeight: 600, fontSize: 14 }}>
                                    Bal: {selectedCryptoForWithdraw?.symbol || selectedCoin.symbol} {selectedCryptoForWithdraw?.balance || selectedCoin.balance}
                                </p>
                            </div>
                            <div className={style.payoutDiv} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '12px', background: '#f5f5f5', borderRadius: '8px', marginTop: '10px' }}>
                                <img src={selectedCryptoForWithdraw?.icon || selectedCoin.icon} alt={selectedCryptoForWithdraw?.name || selectedCoin.name} width={24} height={24} />
                                <p style={{ margin: 0 }}>{selectedCryptoForWithdraw?.symbol || selectedCoin.symbol}</p>
                            </div>
                        </div>

                        {/* Select Network */}
                        <div className={style.labelPut} style={{ marginTop: '15px' }}>
                            <label htmlFor="network">Select Network</label>
                            <div className={style.select} style={{ marginTop: '10px' }} ref={networkSelectRef}>
                                <div className={style.selectInput}
                                 onClick={() => setOpenNetwork(prev => !prev)}
                                 >
                                    <input
                                        type="text"
                                        disabled={browserName === "Firefox" ? false : true}
                                        value={selectedNetworkName}
                                        placeholder="Select Network"
                                        style={{ pointerEvents: "none" }}
                                    />
                                    <ArrowDown2
                                        style={{
                                            transform: openNetwork ? "translateY(-50%) rotate(-540deg)" : "translateY(-50%) rotate(0deg)",
                                            pointerEvents: "none",
                                        }}
                                        className={style.dropDown}
                                        size="20"
                                        color="#909090"
                                        variant="Bold"
                                    />
                                </div>
                                <div style={{ height: openNetwork ? "fit-content" : "0px", maxHeight: 'fit-content' }} className={style.option}>
                                    {availableNetworks && availableNetworks.length > 0 ? (
                                        availableNetworks.map((network, index) => (
                                            <p
                                                id="networkDrop"
                                                key={network.id}
                                                onClick={(e) => handleNetwork(e, network.id)}
                                                style={{ borderBottom: `${index !== availableNetworks.length - 1 ? '1px #90909042 solid' : ''}`, padding: '12px 16px', margin: 0, cursor: 'pointer' }}
                                            >
                                                {network.name}
                                            </p>
                                        ))
                                    ) : (
                                        <p style={{ padding: '12px 16px', margin: 0 }}>No networks available</p>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Wallet Address */}
                        <div className={style.labelPut} style={{ marginTop: '15px' }}>
                            <label htmlFor="walletAddress">Wallet Address<span style={{ color: '#FF0000' }}>*</span></label>
                            <div className={style.input} style={{ marginTop: '10px' }}>
                                <input
                                    type="text"
                                    name="walletAddress"
                                    placeholder="Paste Wallet Address"
                                    value={walletAddress}
                                    onChange={(e) => setWalletAddress(e.target.value)}
                                />
                            </div>

                            {/* Favorites Section */}
                            <div style={{ position: 'relative', width: '100%' }}>
                                <p
                                    id="cryptoFavoritesBtn"
                                    onClick={() => setShowCryptoFavoritesDropdown(!showCryptoFavoritesDropdown)}
                                    style={{ color: '#40196D', textDecoration: 'underline', textAlign: 'right', fontSize: 12, margin: '8px 0 0 0', cursor: 'pointer' }}
                                >
                                    {showCryptoFavoritesDropdown ? 'Hide Favorites' : 'Select from my Favorites'}
                                </p>

                                {showCryptoFavoritesDropdown && (
                                    <div
                                        data-crypto-favorites
                                        style={{
                                            position: 'absolute',
                                            top: '100%',
                                            left: 0,
                                            right: 0,
                                            background: '#ffffff',
                                            border: '1px solid #e8e8e8',
                                            borderRadius: '8px',
                                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                            zIndex: 1000,
                                            maxHeight: '250px',
                                            overflowY: 'auto',
                                            marginTop: '4px'
                                        }}
                                    >
                                        {allCryptoAccounts?.cryptotAccounts?.filter(fav => fav.coin_type?.toLowerCase() === (selectedCryptoForWithdraw?.symbol || selectedCoin.symbol)?.toLowerCase()).length > 0 ? (
                                            <>
                                                <p
                                                    onClick={handleClearCryptoFavorite}
                                                    style={{ borderBottom: '2px solid #f0f0f0', padding: '12px 16px', cursor: 'pointer', margin: 0, fontSize: '12px', color: '#ff4757', fontWeight: '600', fontStyle: 'italic' }}
                                                >
                                                    ✕ Clear Selection (Enter manually)
                                                </p>
                                                {allCryptoAccounts?.cryptotAccounts
                                                    ?.filter(fav => fav.coin_type?.toLowerCase() === (selectedCryptoForWithdraw?.symbol || selectedCoin.symbol)?.toLowerCase())
                                                    .map((favorite, index) => (
                                                        <p
                                                            key={favorite.id}
                                                            onClick={() => handleSelectCryptoFromFavorites(favorite)}
                                                            style={{
                                                                borderBottom: `${index !== allCryptoAccounts.cryptotAccounts.length - 1 ? '1px #90909042 solid' : ''}`,
                                                                padding: '12px 16px',
                                                                cursor: 'pointer',
                                                                margin: 0,
                                                                fontSize: '13px',
                                                                lineHeight: '1.6'
                                                            }}
                                                            onMouseOver={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                                                            onMouseOut={(e) => e.target.style.backgroundColor = 'transparent'}
                                                        >
                                                            <strong>{favorite.coin_name}</strong> - {favorite.network}
                                                            <br />
                                                            <span style={{ fontSize: '11px', color: '#666', wordBreak: 'break-all' }}>
                                                                {favorite.wallet_address}
                                                            </span>
                                                        </p>
                                                    ))}
                                                <p
                                                    onClick={() => setShowAddFavoriteModal(true)}
                                                    style={{ borderTop: '2px solid #f0f0f0', padding: '12px 16px', cursor: 'pointer', margin: 0, fontSize: '12px', color: '#40196D', fontWeight: '600', fontStyle: 'italic', backgroundColor: '#f8f9fa' }}
                                                >
                                                    + Add New Address to Favorites
                                                </p>
                                            </>
                                        ) : (
                                            <>
                                                <p style={{ padding: '12px 16px', margin: 0, color: '#909090', fontSize: '12px' }}>
                                                    No saved addresses yet
                                                </p>
                                                <p
                                                    onClick={() => setShowAddFavoriteModal(true)}
                                                    style={{ borderTop: '1px solid #f0f0f0', padding: '12px 16px', cursor: 'pointer', margin: 0, fontSize: '12px', color: '#40196D', fontWeight: '600', fontStyle: 'italic', backgroundColor: '#f8f9fa' }}
                                                >
                                                    + Add Address to Favorites
                                                </p>
                                            </>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Amount */}
                        <div className={style.labelPut} style={{ marginTop: '15px' }}>
                            <label htmlFor="amount">Amount<span style={{ color: '#FF0000' }}>*</span></label>
                            <div className={style.input} style={{ position: 'relative', marginTop: '10px' }}>
                                <input
                                    type="number"
                                    name="amount"
                                    placeholder="0.00"
                                    value={withdrawAmount}
                                    onChange={(e) => {
                                        const value = e.target.value < 0 ? 0 : e.target.value;
                                        setWithdrawAmount(value);
                                        if (value > 0 && selectedNetworkId) {
                                            debouncedFetchFee(value);
                                        } else {
                                            setWithdrawalFeeData(null);
                                            setFeeError("");
                                        }
                                    }}
                                />
                                <div style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', display: 'flex', gap: '8px' }}>
                                    {['10%', '25%', '50%', '75%', 'Max'].map((percent) => (
                                        <button
                                            key={percent}
                                            type="button"
                                            style={{ background: '#f5f5f5', border: 'none', borderRadius: '4px', padding: '4px 8px', fontSize: '12px', color: '#666', cursor: 'pointer' }}
                                            onClick={() => {
                                                const balance = parseFloat(selectedCryptoForWithdraw?.balance || selectedCoin.balance || 0);
                                                let calculatedAmount;
                                                if (percent === 'Max') {
                                                    calculatedAmount = balance;
                                                } else {
                                                    const percentage = parseInt(percent) / 100;
                                                    calculatedAmount = balance * percentage;
                                                }
                                                const formattedAmount = calculatedAmount.toFixed(6);
                                                setWithdrawAmount(formattedAmount);
                                                if (formattedAmount > 0 && selectedNetworkId) {
                                                    debouncedFetchFee(formattedAmount);
                                                } else {
                                                    setWithdrawalFeeData(null);
                                                    setFeeError("");
                                                }
                                            }}
                                        >
                                            {percent}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Fee Display */}
                        {withdrawalFeeData && (
                            <div style={{ marginTop: '15px', padding: '12px', backgroundColor: '#F5F3F7', borderRadius: '8px', fontSize: '14px' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                                    <span style={{ color: '#909090' }}>Network Fee:</span>
                                    <span style={{ color: '#212121', fontWeight: 600 }}>
                                        {selectedCryptoForWithdraw?.symbol || selectedCoin.symbol} {withdrawalFeeData.fee_amount?.toLocaleString(undefined, { maximumFractionDigits: 8 }) || "0"}
                                    </span>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #E0E0E0', paddingTop: '8px' }}>
                                    <span style={{ color: '#212121', fontWeight: 600 }}>Total Debit:</span>
                                    <span style={{ color: '#40196D', fontWeight: 600 }}>
                                        {selectedCryptoForWithdraw?.symbol || selectedCoin.symbol} {withdrawalFeeData.debit_amount?.toLocaleString(undefined, { maximumFractionDigits: 8 }) || "0"}
                                    </span>
                                </div>
                            </div>
                        )}

                        {feeError && <p style={{ color: '#FF0000', fontSize: '12px', marginTop: '8px' }}>{feeError}</p>}
                        {isLoadingFee && <p style={{ color: '#40196D', fontSize: '12px', marginTop: '8px' }}>Calculating fee...</p>}

                        {withdrawalFeeData && parseFloat(withdrawalFeeData.debit_amount) > parseFloat(selectedCryptoForWithdraw?.balance || selectedCoin.balance || 0) && (
                            <div style={{ backgroundColor: '#FFE0E0', color: '#FF0000', padding: '10px 12px', borderRadius: '6px', fontSize: '12px', marginTop: '15px' }}>
                                Insufficient balance. You need {selectedCryptoForWithdraw?.symbol || selectedCoin.symbol} {(withdrawalFeeData.debit_amount - parseFloat(selectedCryptoForWithdraw?.balance || selectedCoin.balance || 0)).toLocaleString(undefined, { maximumFractionDigits: 8 })} more.
                            </div>
                        )}

                        <button
                            disabled={
                                !withdrawAmount ||
                                !walletAddress ||
                                !selectedNetworkName ||
                                isLoadingFee ||
                                !withdrawalFeeData ||
                                (withdrawalFeeData && parseFloat(withdrawalFeeData.debit_amount) > parseFloat(selectedCryptoForWithdraw?.balance || selectedCoin.balance || 0))
                            }
                            onClick={() => setIsWithdrawInitiated(true)}
                            style={{ marginTop: '20px' }}
                            className={style.save}
                        >
                            {isLoadingFee ? "Calculating fee..." : "Proceed"}
                        </button>
                    </div>
                ) : (
                    /* Confirmation Step */
                    <div style={{ marginTop: '20px' }}>
                        <div onClick={() => setIsWithdrawInitiated(false)} style={{ width: '20px', height: '20px', background: '#40196d1a', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                            <img src={arrow_left} alt="arrow left" />
                        </div>

                        <div style={{ background: '#F5F3F7', marginTop: '20px', borderRadius: '20px', padding: '25px 25px' }}>
                            <p style={{ color: '#212121', fontWeight: '400', textAlign: 'left', fontSize: 14, marginBottom: 0 }}>
                                Please check transaction details
                            </p>

                            <div style={{ marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center' }}>
                                <div><img src={selectedCryptoForWithdraw?.icon || selectedCoin.icon} alt={selectedCryptoForWithdraw?.name || selectedCoin.name} width={24} height={24} /></div>
                                <div>
                                    <h6 style={{ color: '#90909080', fontWeight: '400', fontSize: 14 }}>From Wallet</h6>
                                    <p style={{ marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14 }}>
                                        {selectedCryptoForWithdraw?.name || selectedCoin.name} Wallet
                                    </p>
                                </div>
                            </div>

                            <div style={{ marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center' }}>
                                <div><img src={transactionTypeIcon} alt='transactionTypeIcon' /></div>
                                <div>
                                    <h6 style={{ color: '#90909080', fontWeight: '400', fontSize: 14 }}>Send to</h6>
                                    <p style={{ marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14, wordBreak: 'break-all' }}>
                                        {walletAddress}
                                    </p>
                                </div>
                            </div>

                            <div style={{ marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center' }}>
                                <div><img src={transactionTypeIcon} alt='transactionTypeIcon' /></div>
                                <div>
                                    <h6 style={{ color: '#90909080', fontWeight: '400', fontSize: 14 }}>Network</h6>
                                    <p style={{ marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14 }}>
                                        {selectedNetworkName || "Not Selected"}
                                    </p>
                                </div>
                            </div>

                            <div style={{ marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center' }}>
                                <div><img src={moneyIcon} alt='feeIcon' /></div>
                                <div>
                                    <h6 style={{ color: '#90909080', fontWeight: '400', fontSize: 14, margin: 0 }}>Network Fee</h6>
                                    <p style={{ marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14 }}>
                                        {selectedCryptoForWithdraw?.symbol || selectedCoin.symbol} {withdrawalFeeData?.fee_amount?.toLocaleString(undefined, { maximumFractionDigits: 8 }) || "0"}
                                    </p>
                                </div>
                            </div>

                            <div style={{ marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center' }}>
                                <div><img src={moneyIcon} alt='totalIcon' /></div>
                                <div>
                                    <h6 style={{ color: '#90909080', fontWeight: '400', fontSize: 14, margin: 0 }}>Total Debit</h6>
                                    <p style={{ marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '600', fontSize: 14 }}>
                                        {selectedCryptoForWithdraw?.symbol || selectedCoin.symbol} {withdrawalFeeData?.debit_amount?.toLocaleString(undefined, { maximumFractionDigits: 8 }) || "0"}
                                    </p>
                                </div>
                            </div>

                            <div style={{ marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center' }}>
                                <div><img src={moneyIcon} alt='moneyIcon' /></div>
                                <div>
                                    <h6 style={{ color: '#90909080', fontWeight: '400', fontSize: 14 }}>Amount</h6>
                                    <p style={{ marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14 }}>
                                        {selectedCryptoForWithdraw?.symbol || selectedCoin.symbol} {withdrawAmount}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <button
                            onClick={() => {
                                setIsWalletAddressModal(false);
                                setWithdrawalType("walletAddress");
                                setPutPass(true);
                                setTrPin("");
                                if (pinEle) pinEle.clear();
                            }}
                            style={{ marginTop: '30px' }}
                            className={style.save}
                        >
                            Proceed
                        </button>
                    </div>
                )}
            </Modal>

            {/* ===== ADD TO FAVORITES MODAL ===== */}
            <Modal
                title="Save Wallet Address"
                minWidth="40%"
                canClose
                modalOpen={showAddFavoriteModal}
                setModalOpen={setShowAddFavoriteModal}
            >
                <div style={{ marginTop: '25px' }}>
                    <div className={style.labelPut}>
                        <label htmlFor="favName">Nickname (e.g., 'My Hardware Wallet')<span style={{ color: '#FF0000' }}>*</span></label>
                        <div className={style.input} style={{ marginTop: '10px' }}>
                            <input
                                type="text"
                                name="favName"
                                placeholder="Enter a name for this address"
                                value={newFavCryptoName}
                                onChange={(e) => setNewFavCryptoName(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className={style.labelPut} style={{ marginTop: '15px' }}>
                        <label htmlFor="favNetwork">Network<span style={{ color: '#FF0000' }}>*</span></label>
                        <div className={style.input} style={{ marginTop: '10px' }}>
                            <input
                                type="text"
                                name="favNetwork"
                                placeholder="Network"
                                disabled
                                value={selectedNetworkName}
                            />
                        </div>
                    </div>

                    <div className={style.labelPut} style={{ marginTop: '15px' }}>
                        <label htmlFor="favAddress">Wallet Address<span style={{ color: '#FF0000' }}>*</span></label>
                        <div className={style.input} style={{ marginTop: '10px' }}>
                            <input
                                type="text"
                                name="favAddress"
                                placeholder="Wallet address"
                                value={newFavCryptoAddress}
                                onChange={(e) => setNewFavCryptoAddress(e.target.value)}
                                style={{ wordBreak: 'break-all' }}
                            />
                        </div>
                    </div>

                    <p style={{ fontSize: '12px', color: '#909090', marginTop: '12px' }}>
                        Coin: {selectedCryptoForWithdraw?.name || selectedCoin.name} ({selectedCryptoForWithdraw?.symbol || selectedCoin.symbol})
                    </p>

                    <button
                        disabled={!newFavCryptoAddress || !newFavCryptoName || !selectedNetworkName || isSavingFav}
                        onClick={handleSaveCryptoFavorite}
                        style={{ marginTop: '20px' }}
                        className={style.save}
                    >
                        {isSavingFav ? "Saving..." : "Save Address"}
                    </button>
                </div>
            </Modal>

            {/* ===== INTERNAL TRANSFER MODAL ===== */}
            <Modal
                title={`Withdraw ${selectedCryptoForWithdraw?.name || selectedCoin.name}`}
                minWidth="40%"
                canClose
                modalOpen={isInternalTransferModal}
                setModalOpen={setIsInternalTransferModal}
            >
                {!isWithdrawInitiated ? (
                    <div style={{ marginTop: '25px' }}>
                        {/* From Wallet */}
                        <div className={style.labelPut}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <label htmlFor="wallet">From</label>
                                <p style={{ margin: '0px', color: '#40196D', fontWeight: 600, fontSize: 14 }}>
                                    Balance: {selectedCryptoForWithdraw?.balance || selectedCoin.balance} {selectedCryptoForWithdraw?.symbol || selectedCoin.symbol}
                                </p>
                            </div>
                            <div className={style.payoutDiv} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '12px', background: '#f5f5f5', borderRadius: '8px', marginTop: '10px' }}>
                                <img src={selectedCryptoForWithdraw?.icon || selectedCoin.icon} alt={selectedCryptoForWithdraw?.name || selectedCoin.name} width={24} height={24} />
                                <p style={{ margin: 0 }}>{selectedCryptoForWithdraw?.name || selectedCoin.name}</p>
                            </div>
                        </div>

                        {/* Amount with percentage buttons */}
                        <div className={style.labelPut} style={{ marginTop: '15px' }}>
                            <label htmlFor="amount">Amount<span style={{ color: '#FF0000' }}>*</span></label>
                            <div className={style.input} style={{ position: 'relative', marginTop: '10px' }}>
                                <input
                                    type="number"
                                    name="amount"
                                    placeholder="0.00"
                                    value={withdrawAmount}
                                    onChange={(e) => setWithdrawAmount(e.target.value < 0 ? 0 : e.target.value)}
                                />
                                <div style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', display: 'flex', gap: '8px' }}>
                                    {['10%', '25%', '50%', '75%', 'Max'].map((percent) => (
                                        <button
                                            key={percent}
                                            type="button"
                                            style={{ background: '#f5f5f5', border: 'none', borderRadius: '4px', padding: '4px 8px', fontSize: '12px', color: '#666', cursor: 'pointer' }}
                                            onClick={() => {
                                                const balance = parseFloat(selectedCryptoForWithdraw?.balance || selectedCoin.balance || 0);
                                                if (percent === 'Max') {
                                                    setWithdrawAmount(balance);
                                                } else {
                                                    const percentage = parseInt(percent) / 100;
                                                    setWithdrawAmount((balance * percentage).toFixed(6));
                                                }
                                            }}
                                        >
                                            {percent}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Astro Tag */}
                        <div className={style.labelPut} style={{ marginTop: '15px' }}>
                            <label htmlFor="astroTag">Astro Tag<span style={{ color: '#FF0000' }}>*</span></label>
                            <div className={style.input} style={{ marginTop: '10px' }}>
                                <input
                                    type="text"
                                    name="astroTag"
                                    placeholder="Enter astro username"
                                    value={astroTag}
                                    onChange={(e) => setAstroTag(e.target.value)}
                                />
                            </div>
                            {userNotFound && (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '8px' }}>
                                    <InfoCircle size="20" variant="Bold" color="#F40000" />
                                    <p style={{ margin: '0px', color: '#F40000', fontSize: '12px' }}>User not found. Please check the AstroTag.</p>
                                </div>
                            )}
                        </div>

                        {/* Astro Account Name */}
                        <div className={style.labelPut} style={{ marginTop: '15px' }}>
                            <label htmlFor="accountName">Astro Account Name</label>
                            <div className={style.input} style={{ position: 'relative', marginTop: '10px' }}>
                                <input
                                    type="text"
                                    name="accountName"
                                    placeholder="Astro Account Name"
                                    disabled
                                    value={accountName}
                                />
                                {isLoadingName && (
                                    <div style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)' }}>
                                        <Lottie
                                            style={{ width: "30px", height: "30px", color: "#fff", padding: "0px", margin: "0px" }}
                                            animationData={loader}
                                            loop={true}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>

                        <button
                            disabled={!withdrawAmount || !astroTag || !accountName || isLoadingName}
                            onClick={() => setIsWithdrawInitiated(true)}
                            style={{ marginTop: '20px' }}
                            className={style.save}
                        >
                            Proceed
                        </button>
                    </div>
                ) : (
                    /* Confirmation Step */
                    <div style={{ marginTop: '20px' }}>
                        <div onClick={() => setIsWithdrawInitiated(false)} style={{ width: '20px', height: '20px', background: '#40196d1a', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                            <img src={arrow_left} alt="arrow left" />
                        </div>

                        <div style={{ background: '#F5F3F7', marginTop: '20px', borderRadius: '20px', padding: '25px 25px' }}>
                            <p style={{ color: '#212121', fontWeight: '400', textAlign: 'left', fontSize: 14, marginBottom: 0 }}>
                                Please check transaction details
                            </p>

                            <div style={{ marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center' }}>
                                <div><img src={selectedCryptoForWithdraw?.icon || selectedCoin.icon} alt={selectedCryptoForWithdraw?.name || selectedCoin.name} width={24} height={24} /></div>
                                <div>
                                    <h6 style={{ color: '#90909080', fontWeight: '400', fontSize: 14 }}>From Wallet</h6>
                                    <p style={{ marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14 }}>
                                        {selectedCryptoForWithdraw?.name || selectedCoin.name} Wallet
                                    </p>
                                </div>
                            </div>

                            <div style={{ marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center' }}>
                                <div><img src={transactionTypeIcon} alt='transactionTypeIcon' /></div>
                                <div>
                                    <h6 style={{ color: '#90909080', fontWeight: '400', fontSize: 14 }}>Send to</h6>
                                    <p style={{ marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14 }}>
                                        {astroTag}
                                    </p>
                                </div>
                            </div>

                            <div style={{ marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center' }}>
                                <div><img src={transactionTypeIcon} alt='accountIcon' /></div>
                                <div>
                                    <h6 style={{ color: '#90909080', fontWeight: '400', fontSize: 14 }}>Account Name</h6>
                                    <p style={{ marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14 }}>
                                        {accountName}
                                    </p>
                                </div>
                            </div>

                            <div style={{ marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center' }}>
                                <div><img src={transactionTypeIcon} alt='transactionTypeIcon' /></div>
                                <div>
                                    <h6 style={{ color: '#90909080', fontWeight: '400', fontSize: 14 }}>Transfer Type</h6>
                                    <p style={{ marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14 }}>
                                        Internal Transfer
                                    </p>
                                </div>
                            </div>

                            <div style={{ marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center' }}>
                                <div><img src={moneyIcon} alt='moneyIcon' /></div>
                                <div>
                                    <h6 style={{ color: '#90909080', fontWeight: '400', fontSize: 14 }}>Amount</h6>
                                    <p style={{ marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14 }}>
                                        {selectedCryptoForWithdraw?.symbol || selectedCoin.symbol} {withdrawAmount}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <button
                            onClick={() => {
                                setIsInternalTransferModal(false);
                                setWithdrawalType("internalTransfer");
                                setPutPass(true);
                                setTrPin("");
                                if (pinEle) pinEle.clear();
                            }}
                            style={{ marginTop: '30px' }}
                            className={style.save}
                        >
                            Proceed
                        </button>
                    </div>
                )}
            </Modal>

            {/* ===== LOADING MODAL ===== */}
            <Modal canClose={false} modalOpen={isOpen} setModalOpen={setIsOpen}>
                <div>
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '25px' }}>
                        <img src={spin_circle} alt="spin circle" className={style.animate_spin} />
                    </div>
                    <div>
                        <h4 style={{ color: '#40196D', fontWeight: '600', marginTop: '25px' }}>Processing</h4>
                        <p style={{ color: '#B6B6B6', maxWidth: '300px', margin: 'auto', marginTop: '15px' }}>
                            Please wait...
                        </p>
                    </div>
                </div>
            </Modal>

            {/* ===== SUCCESS MODAL ===== */}
            <Modal canClose={true} modalOpen={isSuccessModal} setModalOpen={setSuccessModal}>
                <div>
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '25px' }}>
                        <img src={successIcon} alt="check mark circle" />
                    </div>
                    <div>
                        <h4 style={{ color: '#40196D', fontWeight: '600', marginTop: '25px' }}>Transaction Successful</h4>
                        <p style={{ color: '#B6B6B6', maxWidth: '300px', margin: 'auto', marginTop: '15px' }}>
                            Your transaction has been successfully processed.
                        </p>
                    </div>
                    <button onClick={() => setSuccessModal(false)} style={{ marginTop: '20px' }} className={style.save}>
                        Continue
                    </button>
                </div>
            </Modal>

            {/* ===== TRANSACTION PIN MODAL ===== */}
            <Modal canClose={true} modalOpen={putPass} setModalOpen={setPutPass}>
                <div className={style.setTrPin}>
                    <h2 className={style.pinHead}>Transaction Pin</h2>
                    <p>Please input your transaction pin</p>
                    <div className={style.inputs2}>
                        <PinInput
                            length={5}
                            initialValue=""
                            secret={true}
                            ref={(n) => { pinEle = n; }}
                            onChange={(value, index) => { setTrPin(value); }}
                            type="numeric"
                            inputMode="number"
                            style={{ padding: "10px", margin: "0 auto 0 auto" }}
                            inputStyle={{ border: "1px solid", borderColor: "#909090" }}
                            inputFocusStyle={{ border: "2px solid", borderColor: "#40196D" }}
                            onComplete={(value, index) => { setTrPin(value); }}
                            autoSelect={true}
                            regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                        />
                    </div>
                    <button disabled={pinDisabled} className={style.save} onClick={handleWithdrawal}>
                        Withdraw Funds
                    </button>
                </div>
            </Modal>

            {/* ===== MAIN PAGE CONTENT ===== */}
            {/* Top Section - Side by Side */}
            <div className={style.cryptoWalletTopSection}>
                {/* Wallet Balance Card */}
                <div className={style.cryptoBalanceCard}>
                    <div className={style.cryptoBalanceLeft}>
                        <div className={style.cryptoBalanceLabel}>WALLET BALANCE</div>
                        <div className={style.cryptoBalanceAmount}>
                            {visible === true
                                ? `${parseFloat(selectedCoin.balance || 0).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 8 })}`
                                : '********'}
                            {visible === true ? (
                                <EyeSlash onClick={() => setVisible(!visible)} className={style.walEye} color="#40196D" variant="Bulk" style={{ cursor: 'pointer' }} />
                            ) : (
                                <Eye onClick={() => setVisible(!visible)} className={style.walEye} color="#40196D" variant="Bulk" style={{ cursor: 'pointer' }} />
                            )}
                        </div>
                        <div className={`${style.cryptoBalanceChange} ${selectedCoin.price_change_percentage > 0 ? style.priceChangeUp : style.priceChangeDown}`}>
                            {selectedCoin.price_change_percentage > 0 ? "↑" : "↓"}
                            {selectedCoin.price_change_percentage > 0 ? "+" : ""}{selectedCoin.price_change_percentage?.toFixed(2) || "0.00"}% in the last 24 hours
                        </div>
                    </div>
                    <div className={style.cryptoBalanceRight}>
                        <div className={style.cryptoCoinBadge}>
                            <img src={selectedCoin.icon} alt={selectedCoin.symbol} className={style.cryptoCoinIcon} />
                            <span className={style.cryptoCoinSymbol}>{selectedCoin.name}</span>
                        </div>
                    </div>
                </div>

                {/* Action Buttons */}
                <div className={style.cryptoWalletActions}>
                    <div className={style.cryptoWalletAction} onClick={() => setIsSwapModalOpen(true)}>
                        <div className={style.cryptoActionIconWrap}>
                            <img src={swapIcon} alt="Swap" style={{ width: '24px', height: '24px' }} />
                        </div>
                        <span>Swap</span>
                    </div>
                    <div className={style.cryptoWalletAction} onClick={handleOpenWithdrawModal}>
                        <div className={style.cryptoActionIconWrap}>
                            <img src={withdrawIcon} alt="withdrawIcon" style={{ width: '24px', height: '24px' }} />
                        </div>
                        <span>Withdraw</span>
                    </div>
                <div className={style.cryptoWalletAction} onClick={() => setIsCryptoReceiveModalOpen(true)}>
                    <div className={style.cryptoActionIconWrap}>
                        <img src={receiveIcon} alt="receiveIcon" style={{ width: '24px', height: '24px' }} />
                    </div>
                    <span>Receive</span>
                </div>
                </div>
            </div>

            {/* Recent Transactions */}
            <div className={style.recentTransactionsTitle}>Recent Transactions</div>

            <section className={style.transactionsSection}>
                <div className={style.transactionsHeader}>
                    <div>
                        <label style={{ marginRight: 8 }}>Per page</label>
                        <select value={txPerPage} onChange={e => { setTxPerPage(Number(e.target.value)); setTxPage(0); }}>
                            <option value={15}>15</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                        </select>
                    </div>
                </div>

                <div className={style.table}>
                    <table>
                        <thead>
                            <tr>
                                <th><div className={style.tableHead}><h5>Transaction</h5></div></th>
                                <th><div className={style.tableHead}><h5>Date</h5></div></th>
                                <th><div className={style.tableHead}><h5>Hash ID</h5></div></th>
                                <th><div className={style.tableHead}><h5>Amount</h5></div></th>
                                <th><div className={style.tableHead}><h5>Status</h5></div></th>
                            </tr>
                        </thead>
                        <tbody>
                            {isLoadingTransactions ? (
                                <tr><td colSpan="5">Loading...</td></tr>
                            ) : transactions.length === 0 ? (
                                <tr><td colSpan="5">No transactions</td></tr>
                            ) : (
                                transactions.map((tx) => {
                                    const iconSrc = tx.type && tx.type.toLowerCase().includes("withdraw")
                                        ? withdrawIcon
                                        : tx.type && tx.type.toLowerCase().includes("deposit")
                                            ? receiveIcon
                                            : swapIcon;
                                    const fromCurrency = (tx.data?.from_currency || "").toUpperCase();
                                    const toCurrency = (tx.data?.to_currency || "").toUpperCase();
                                    const displayRef = tx.data?.txid || 'N/A';
                                    return (
                                        <tr key={tx.id} className={style.fullRow}>
                                            <td className={style.user}>
                                                <div className={style.tableHead}>
                                                    <div className={style.image} style={{ flexShrink: 0, borderRadius: '0%' }}>
                                                        <img src={iconSrc} alt={tx.type} />
                                                    </div>
                                                    <div className={style.name}>
                                                        <h6>{formatType(tx.type)}</h6>
                                                        <p>
                                                            {tx.type === "crypto_to_crypto"
                                                                ? `${fromCurrency} to ${toCurrency}`
                                                                : ""}
                                                        </p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className={style.date}>
                                                    <h6>{tx.created_at ? moment(tx.created_at).format("MMM D, YYYY") : "-"}</h6>
                                                    <p>at {tx.created_at ? moment(tx.created_at).format("hh:mm A") : "-"}</p>
                                                </div>
                                            </td>
                                           <td>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <p className={style.invoice}>
                                                    {displayRef?.substring(0, 25)}
                                                </p>
                                                {displayRef && displayRef !== "N/A" && (
                                                    <button
                                                        onClick={() => {
                                                            navigator.clipboard.writeText(displayRef);
                                                            // Show toast notification
                                                          cogoToast.success("Hash ID copied to clipboard", { position: 'top-right' });
                                                        }}
                                                        style={{
                                                            background: 'none',
                                                            border: 'none',
                                                            cursor: 'pointer',
                                                            padding: '4px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            flexShrink: 0,
                                                            color: '#40196D'
                                                        }}
                                                        title="Copy"
                                                    >
                                                        <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                                            <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
                                                            <path d="M15 2H9a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z" />
                                                        </svg>
                                                    </button>
                                                )}
                                            </div>
                                        </td>
                                            <td>
                                                <p className={style.amount} style={{ textAlign: 'left' }}>
                                                         {getTransactionAmountAndCurrency(tx)}
                                                </p>
                                            </td>
                                            <td>
                                                <div className={
                                                    `${tx.status.toLowerCase() === "completed" ? style.success :
                                                      tx.status.toLowerCase() === "pending" || tx.status.toLowerCase() === 'pending_admin' ? style.pending :
                                                      tx.status.toLowerCase() === "failed" ? style.error :
                                                      style.pending
                                                    }`
                                                }>
                                                {tx.status.replace(/_/g, " ")}
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </table>

                    {/* Mobile View */}
                    <div className={style.transList}>
                        {transactions.map((tx) => {
                            const iconSrc = tx.type && tx.type.toLowerCase().includes("withdraw")
                                ? withdrawIcon
                                : tx.type && tx.type.toLowerCase().includes("deposit")
                                    ? receiveIcon
                                    : swapIcon;
                            const fromCurrency = (tx.data?.from_currency || "").toUpperCase();
                            const toCurrency = (tx.data?.to_currency || "").toUpperCase();
                            const displayRef = tx.data?.confirmation_id || tx.quidax_user_id || tx.id;
                            return (
                                <div className={style.eachTrans} key={tx.id}>
                                    <div className={style.et}>
                                        <div className={style.etPic} style={{ flexShrink: 0 }}>
                                            <img src={iconSrc} alt={tx.type} />
                                        </div>
                                        <div className={style.etTitle}>
                                            <h4>{formatType(tx.type)}</h4>
                                            <p>{tx.type === "crypto_to_crypto" ? `${fromCurrency} to ${toCurrency}` : toCurrency || fromCurrency}</p>
                                        </div>
                                        <div className={style.etTime}>
                                            <p>{getTransactionAmountAndCurrency(tx)}</p>
                                            <span>{tx.created_at ? moment(tx.created_at).format("MMM D") : ""}</span>
                                        </div>
                                    </div>
                                    <div className={style.etDet}>
                                        <p>Ref ID: {displayRef}</p>
                                        <div className={style.success}>{tx.status}</div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                <div className={style.txPagination} style={{ display: "flex", justifyContent: "space-between", marginTop: 12, paddingBottom: 24 }}>
                    <div>
                        <button disabled={txPage <= 0} onClick={() => setTxPage(p => Math.max(0, p - 1))}>Prev</button>
                        <button
                            disabled={(transactionsMeta.count || 0) <= (txPage + 1) * txPerPage}
                            onClick={() => setTxPage(p => p + 1)}
                            style={{ marginLeft: 8 }}
                        >
                            Next
                        </button>
                    </div>
                    <div>
                        Page {transactionsMeta.page ?? txPage} — {transactionsMeta.count ?? transactions.length} total
                    </div>
                </div>
            </section>
        </>
    );
}

export default CryptoWalletPage;